import React from 'react';
import { MarketingLayout } from '@byscott-io/corebyscott';

export default function ContactPage() {
  return (
    <MarketingLayout>
      <div className="py-16 px-4">
        <div className="max-w-xl mx-auto">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-8 text-center">
            Contact Us
          </h1>

          <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-8">
            <p className="text-gray-600 dark:text-gray-400 mb-6">
              Have questions, feedback, or need help? We'd love to hear from you.
            </p>

            <div className="space-y-4">
              <div>
                <h3 className="font-semibold text-gray-900 dark:text-white mb-1">Email</h3>
                <a
                  href="mailto:support@ideas.byscott.io"
                  className="text-indigo-600 hover:underline"
                >
                  support@ideas.byscott.io
                </a>
              </div>

              <div>
                <h3 className="font-semibold text-gray-900 dark:text-white mb-1">Report Issues</h3>
                <p className="text-gray-600 dark:text-gray-400">
                  If you're a registered user, use the Support page in the app to report issues
                  and track their status.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MarketingLayout>
  );
}
